export default __webpack_public_path__ + "static/202106cp_img-90488b604a3ea8a602db037c210a9b16.jpg";